module.exports = __webpack_public_path__ + "img/zhang.1b10cf10.jpg";